import { Component } from "@angular/core";

@Component({
  selector: "app-cnet-teams-content",
  templateUrl: "cnet-teams-content.component.html",
})
export class CnetTeamsContentComponent {}
